import { render, staticRenderFns } from "./currencyAssets.vue?vue&type=template&id=2381669e"
import script from "./currencyAssets.vue?vue&type=script&lang=js"
export * from "./currencyAssets.vue?vue&type=script&lang=js"
import style0 from "./currencyAssets.vue?vue&type=style&index=0&id=2381669e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports